export default "__VITE_ASSET__B3mR4B0n__"